import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ViewMode } from '../../../../models';
import {
  BannerVariant,
  ComponentPlacement,
  TimerFormat,
} from '../../../extension-components/delivery-countdown-timer/components/delivery-countdown-timer/models';

@Component({
  selector: 'delivery-countdown-timer-example',
  templateUrl: './delivery-countdown-timer-example.component.html',
  styleUrls: ['./delivery-countdown-timer-example.component.scss'],
  standalone: false,
  encapsulation: ViewEncapsulation.None,
})
export class DeliveryCountdownTimerExampleComponent {
  @Input() template: any;
  @Input() mode: ViewMode = null;
  @Input() isMobile: boolean = false;

  ComponentPlacement = ComponentPlacement;
  TimerFormat = TimerFormat;

  get bannerVariant(): BannerVariant {
    return this.template?.appearance?.backgroundColor || 'info';
  }

  get bannerIcon(): string {
    const iconMap: Record<BannerVariant, string> = {
      info: 'more_information',
      success: 'v_icon',
      warning: 'Attention',
      critical: 'error',
    };
    return iconMap[this.bannerVariant];
  }
}
